import React from "react";
import "./AnnouncementBar.css";

const AnnouncementBar = () => {
  return (
    <div className="announcement-bar">
      <div className="scroll-text">
        Welcome to the new Xylus Store — Your premium shopping experience starts now 
      </div>
    </div>
  );
};

export default AnnouncementBar;
